import { selectRoomAsyncResponse } from "./types";
import * as roomActions from "./rooms.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_ROOM, retrieveToken } from "../../../helpers/api";

export function* selectRoom(action: ReturnType<typeof roomActions.selectRoomAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_ROOM.SELECT_ROOM(action.payload.id), token);
    if (result.status === 200) {
      const parsed: selectRoomAsyncResponse = yield call(result.json.bind(result));
      yield put(roomActions.selectRoomAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(roomActions.selectRoomAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roomActions.selectRoomAsync.failure(parsed));
  }
}

export default function* roomsSagaSelectRoom() {
  yield takeEvery(roomActions.selectRoomAsync.request, selectRoom);
}
